export default function (s) {
    s.chartjs.each(function () {
        var myChart = new Chart($(this), {
            type: 'pie',
            data: {
                labels: ["40%", "30%", "10%", "5%", "5%", "2.5%", "2.5%", "2.5%", "2.5%"],
                datasets: [{
                    data: [40, 30, 10, 5, 5, 2.5, 2.5, 2.5, 2.5],
                    backgroundColor: [
                        'rgba(75, 127, 140, 1)',
                        'rgba(9, 162, 117, 1)',
                        'rgba(21, 101, 112, 1)',
                        'rgb(105,108,136)',
                        'rgb(245,128,38)',
                        'rgb(223,75,53)',
                        'rgb(102,186,223)',
                        'rgb(116,192,84)',
                        'rgb(75,127,140)'
                    ],
                    borderColor: [
                        'rgba(75, 127, 140, 1)',
                        'rgba(9, 162, 117, 1)',
                        'rgba(21, 101, 112, 1)',
                        'rgb(105,108,136)',
                        'rgb(245,128,38)',
                        'rgb(223,75,53)',
                        'rgb(102,186,223)',
                        'rgb(116,192,84)',
                        'rgb(75,127,140)'
                    ],
                    hoverBackgroundColor: [
                        'rgba(21, 101, 112, 1)',
                        'rgba(21, 101, 112, 1)',
                        'rgba(245, 128, 38, 1)',
                        'rgb(9,162,117)',
                        'rgb(102,186,223)',
                        'rgb(105,108,136)',
                        'rgb(245,128,38)',
                        'rgb(9,162,117)',
                        'rgba(21, 101, 112, 1)',
                    ],
                    hoverBorderColor: [
                        'rgba(21, 101, 112, 1)',
                        'rgba(21, 101, 112, 1)',
                        'rgba(245, 128, 38, 1)',
                        'rgb(9,162,117)',
                        'rgb(102,186,223)',
                        'rgb(105,108,136)',
                        'rgb(245,128,38)',
                        'rgb(9,162,117)',
                        'rgba(21, 101, 112, 1)',
                    ],
                    borderWidth: 1
                }]
            },
            options: {
                legend: {
                    display: false
                },
            }
        });
    });    
}
